(function(){
    angular
        .module('appback')
        .directive('ngRaton', raton);

        raton.$inject = ['$timeout'];
        function raton( $timeout){
            return {
	             restrict: 'A',
            	link: function (scope, element, $attrs, ngModel) {
		            return $timeout(function () {
		            	$(element).append("<span class='raton'></span>");
		            	/*$(element).mouseover(function(e){
		            		//console.log("OVER");
		            		//$(element).find(".raton").show();
		            	});*/

		            	$(element).mouseout(function(e){
		            		//console.log("OVER");
		            		$(element).find(".raton").hide();
		            	});

		            	$(element).mousemove(function(e){
		            		//console.log("e",e);
		            		var y = e.offsetY;
		            		var x = e.offsetX;
		            		//setTimeout(function(){
		            			$(element).find(".raton").css({
							        top: (y)+"px",
							        left:(x)+"px",
							    });
		            			$(element).find(".raton").show();

		            		//},100)
		            		
						})
		            });
		        }
          }
      	}
})();